import { createContext, useCallback } from 'react';
import toast from 'react-hot-toast';

export const ToastContext = createContext({});

export const ToastProvider = ({ children }) => {
  const showSuccess = useCallback((message, options = {}) => {
    toast.success(message, {
      duration: 4000,
      ...options,
    });
  }, []);

  const showError = useCallback((message, options = {}) => {
    toast.error(message, {
      duration: 5000,
      ...options,
    });
  }, []);

  const showWarning = useCallback((message, options = {}) => {
    toast(message, {
      icon: '⚠️',
      duration: 4000,
      ...options,
    });
  }, []);

  const showInfo = useCallback((message, options = {}) => {
    toast(message, {
      icon: 'ℹ️',
      duration: 4000,
      ...options,
    });
  }, []);

  const showLoading = useCallback((message = 'Carregando...') => {
    return toast.loading(message);
  }, []);

  const dismissToast = useCallback((toastId) => {
    toast.dismiss(toastId);
  }, []);

  const showPromise = useCallback((promise, messages) => {
    return toast.promise(promise, {
      loading: messages.loading || 'Carregando...',
      success: messages.success || 'Sucesso!',
      error: messages.error || 'Erro!',
    });
  }, []);

  const value = {
    success: showSuccess,
    error: showError,
    warning: showWarning,
    info: showInfo,
    loading: showLoading,
    dismiss: dismissToast,
    promise: showPromise,
  };

  return (
    <ToastContext.Provider value={value}>
      {children}
    </ToastContext.Provider>
  );
};

export default ToastContext;
